import Vue from 'vue';
import Router from 'vue-router';
import agencyToVendor from '@/views/Invitations/agencyToVendor';
import vendorToAgency from '@/views/Invitations/vendorToAgency';
import vendorToVendor from '@/views/Invitations/vendorToVendor';
import GetListedConfirm from '@/views/Invitations/GetListedConfirm';
import teamInviteVendor from '@/views/Invitations/teamInviteVendor';
import teamInviteAgency from '@/views/Invitations/teamInviteAgency';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/invitations/vendor/:id',
      component: agencyToVendor,
    },
    {
      path: '/invitations/agency/:id',
      component: vendorToAgency,
    },
    {
      path: '/invitations/integration/:id',
      component: vendorToVendor,
    },
    {
      path: '/invitations/team/vendor/:id',
      component: teamInviteVendor,
    },
    {
      path: '/invitations/team/agency/:id',
      component: teamInviteAgency,
    },
    {
      path: '/invitations/get/listed/confirmation/by_user/:dir/:org/:user',
      component: GetListedConfirm,
      name: 'getListedConfirm',
    },
  ],
});
